import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useSubscription } from '@/app/common/graphql/hooks'
import { createQueryKey } from '@/app/common/graphql/utils'
import {
  GetDealAndCalculationByIdDocument,
  GetDealsForCustomerDocument,
  OnlinePaymentSucceededDocument,
  OnlinePaymentSucceededSubscription,
  OnlinePaymentSucceededSubscriptionVariables,
} from '@/types/gql/graphql'

const OnlinePaymentSubscription: React.FC = () => {
  const client = useQueryClient()
  const router = useRouter()

  useSubscription<
    OnlinePaymentSucceededSubscription,
    OnlinePaymentSucceededSubscriptionVariables
  >(OnlinePaymentSucceededDocument, {
    onData: (data) => {
      console.log('subscription', data, data.onlinePaymentSucceeded._id)
      if (data.onlinePaymentSucceeded) {
        client.invalidateQueries({
          queryKey: createQueryKey(GetDealsForCustomerDocument),
        })

        const [documentHash] = createQueryKey(GetDealAndCalculationByIdDocument)
        client.invalidateQueries({
          predicate: (query) => {
            const [queryDocHash, queryArgs] = query.queryKey
            const isQuery = queryDocHash === documentHash
            if (isQuery) console.log('query args', queryArgs)
            const isDeal =
              isQuery &&
              typeof queryArgs === 'object' &&
              queryArgs !== null &&
              'dealId' in queryArgs &&
              queryArgs.dealId === data.onlinePaymentSucceeded._id

            return isQuery && isDeal
          },
        })
      }
    },
    skip: !router.pathname.includes('/profile'),
  })

  return null
}

export default OnlinePaymentSubscription
